export default [{
    path: '/portefeuille/',
    name: 'portefeuille',
    component: () => import('@/views/assureur/portefeuille/Portefeuille.vue'),
},
]